module.exports = "/_next/static/images/yuval-gnessin-b95bd6dc6d3736e8ab1a530b5c1f6a14.jpg";